module.exports = __webpack_public_path__ + "static/img/desc.9354f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desc.png
// module id = Iw4P
// module chunks = 0